import { render, staticRenderFns } from "./ThreeDsAuth.vue?vue&type=template&id=1fce16cc&scoped=true&"
import script from "./ThreeDsAuth.vue?vue&type=script&lang=js&"
export * from "./ThreeDsAuth.vue?vue&type=script&lang=js&"
import style0 from "./ThreeDsAuth.vue?vue&type=style&index=0&id=1fce16cc&prod&lang=scss&scoped=true&"
import style1 from "./ThreeDsAuth.vue?vue&type=style&index=1&id=1fce16cc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fce16cc",
  null
  
)

export default component.exports